import React from 'react';
import TranslatedCopy from '../../../intl/translated-copy';
import Pictogram from '../pictogram';
import { connect } from 'react-redux';
import { HomeE4 } from '../../../../routing/urls';

const BillingFlowEnd = ({
  country,
  language,
  singleBilling,
  stampingBilling,
  version,
}) => {
  const info = {
    image: '',
    billtype: '',
    title: '',
    subtitle: '',
    buttonCopyId: '',
    buttonCallback: '',
  };
  const fetchAndDownloadPdf = () => {
    try {
      // eslint-disable-next-line no-unused-expressions
      stampingBilling?.ticketStampingArray.forEach(ticket => {
        const pdfBytes = ticket?.pdfBytes;
        if (!pdfBytes) {
          throw new Error('No PDF data available');
        }
  
        const binaryData = typeof pdfBytes === 'string' 
          ? Uint8Array.from(atob(pdfBytes), c => c.charCodeAt(0))
          : pdfBytes;
        
        const blob = new Blob([binaryData], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = ticket?.eticket;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error downloading PDF:', error);
    }
  };

  const fetchAndDownloadXml = () => {
    try {
      // eslint-disable-next-line no-unused-expressions
      stampingBilling?.ticketStampingArray.forEach(ticket => {
        const xmlBytes = ticket?.xmlBytes;
        if (!xmlBytes) {
          throw new Error('No XML data available');
        }
  
        const xmlContent = typeof xmlBytes === 'string' 
          ? atob(xmlBytes)
          : new TextDecoder().decode(xmlBytes);
        
        const blob = new Blob([xmlContent], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = ticket?.eticket;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error downloading XML:', error);
    }
  };

  switch (version) {
    case 'success':
      info.image = 'SuccessfulTaxData';
      info.billtype = 'MYB_SUCCESSFUL_INVOICE';
      info.title = 'MYB_INVOICE_GENERATED_SUCCESSFULLY';
      info.subtitle = '';
      info.buttonCopyId = 'MYB_DOWNLOAD';
      info.buttonCallback = () => {
        fetchAndDownloadPdf();
        fetchAndDownloadXml();
      };
      break;
    case 'notBillable':
      const notBillableMsg = singleBilling?.ticketBillingArray.find(ticket=>ticket.motivoCodigoFacturable !== '');
      const msg = notBillableMsg ? notBillableMsg.motivoCodigoFacturable.split('|') : '';
      info.image = 'UnsuccessfulTaxData';
      info.billtype = 'MYB_INVOICE_NOT_SUCCESSFULL';
      info.title = notBillableMsg && msg[0] !== '' ? msg[0] : 'MYB_INVOICE_MODAL_NOT_PERMITED_COPYE';
      info.subtitle = notBillableMsg ? '' : 'MYB_INVOICE_MODAL_NOT_PERMITED_RETRY';
      info.buttonCopyId = 'CC_RETRY';
      info.buttonCallback = () => {};
      break;
    case 'error':
      info.image = 'UnsuccessfulTaxData';
      info.billtype = 'MYB_INVOICE_NOT_SUCCESSFULL';
      info.title = 'MYB_SORRY_THERE_WAS_A_DISCONNECTION';
      info.subtitle = 'MYB_PLEASE_TRY_LATER';
      info.buttonCopyId = 'CC_RETRY';
      info.buttonCallback = () => window.location.reload();
      break;
    case 'expired':
      info.image = 'ExpiredTaxDataModal';
      info.billtype = 'MYB_EXPIRED_TIME';
      info.title = 'MYB_YOUR_TIME_TO_GENERATE_HAS_EXPIRED';
      info.subtitle = 'MYB_REMEBER_ONLY_DAYS_TO_DO_IT';
      info.buttonCopyId = 'MYB_EXIT_REFUND';
      info.buttonCallback = () => window.location.href = HomeE4(language, country);
      break;
  }
  return (
    <div className='BillingFlowEnd'>
      <Pictogram
        className='BillingFlowEnd-image'
        id={ info?.image }
      />
      <TranslatedCopy
        className={`BillingFlowEnd-imageText ${ version === 'success' ? 'successColor' : 'errorColor'}`}
        copyID={ info?.billtype }
      />
      <TranslatedCopy
        className={`BillingFlowEnd-title ${ version === 'success' ? 'newMargin' : null}`}
        copyID={ info?.title }
      />
      { version !== 'success' &&
        <TranslatedCopy
          className='BillingFlowEnd-subtitle'
          copyID={ info?.subtitle }
        />
      }
      { version !== 'notBillable' &&
        <button
          className='BillingFlowEnd-button'
          onClick = { info?.buttonCallback }
        >
          <TranslatedCopy copyID={ info?.buttonCopyId }/>
          { version === 'success' &&
            <Pictogram
              className='BillingFlowEnd-button-icon'
              id='DownloadWhiteLogo'
            />
          }
        </button>
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  country: state.LanguageBundle.country,
  language: state.Manage.language,
  singleBilling: state.singleBilling,
  stampingBilling: state.stampingBilling,
});

export default connect(mapStateToProps)(BillingFlowEnd);